import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { Component } from '@angular/core';

@Component({
    selector: 'cv-contact-list-image-cell-renderer',
    templateUrl: './contact-list-image-cell-renderer.component.html',
    styleUrls: ['./contact-list-image-cell-renderer.component.scss']
})
export class ContactListImageCellRendererComponent implements AgRendererComponent {

    params: ICellRendererParams;
    imageUrl = '';
    state = '';

    constructor() { }

    refresh(params: ICellRendererParams): boolean {
        this.params = params;
        this.state = params.value;
        this.imageUrl = this.getImgUrl(this.state);

        return true;
    }

    agInit(params: ICellRendererParams): void {
        this.params = params;
        this.state = params.value;
        this.imageUrl = this.getImgUrl(this.state);
    }

    private getImgUrl(state: string) {
        let url;
        state = state.toUpperCase(); //  Standardize the state to upper case
        switch (state) {
            case 'PHONE CALL':
                return url = "../App_Themes/CXone/icons/widget-call.svg#widget-call";
            case 'INBOUND':
                return url = "../App_Themes/CXone/icons/inbound.svg#inbound";
            case 'OUTBOUND':
                return url = "../App_Themes/CXone/icons/outbound.svg#outbound";
            case 'CHAT':
            case 'LIVECHAT':
            case 'LIVECHAT PUBLIC':
                return url = "../App_Themes/CXone/icons/widget-chat.svg#widget-chat";
            case 'VOICE MAIL' :
                return url = "../App_Themes/CXone/icons/channels/voicemail.svg#voicemail"; // change when we have
            case 'SMS':
                return url = "../App_Themes/CXone/icons/widget-sms.svg#widget-sms";
            case 'E-MAIL':
                return url = "../App_Themes/CXone/icons/widget-email.svg#widget-email";
            case 'WORK ITEM':
                return url = "../App_Themes/CXone/icons/widget-work-item.svg#widget-work-item";
            case 'DIGITAL':
                return url = "../App_Themes/CXone/icons/social/digital-engagement.svg#digital-engagement";
            case 'SLACK':
            case 'SLACK PUBLIC':
                return url = "../App_Themes/CXone/icons/social/slack.svg#slack";
            case 'TELEGRAM':
            case 'TELEGRAM PUBLIC':
            case 'TELEGRAM MESSAGING':
                return url = "../App_Themes/CXone/icons/social/telegram.svg#telegram";
            case 'CHANNEL': // from here below not 100 percent sure they will actually be used in this widget
                return url = "../App_Themes/CXone/icons/social/channel.svg#channel";
            case 'APPLE':
            case 'APPLE APPS REVIEW':
            case 'APPLE BUSINESS CHAT':
                return url = "../App_Themes/CXone/icons/social/apple.svg#apple";
            case 'GOOGLE BUSINESS MESSENGER':
            case 'GOOGLE PLACES':
                return url = "../App_Themes/CXone/icons/social/google-business-messenger.svg#google-business-messenger";
            case 'LINE':
            case 'LINE MESSAGING':
            case 'LINE PUBLIC':
                return url = "../App_Themes/CXone/icons/social/line.svg#line";
            case 'TEAMS MSG':
            case 'MICROSOFT TEAMS':
            case 'MICROSOFT TEAMS PUBLIC':
                return url = "../App_Themes/CXone/icons/social/teams-msg.svg#teams-msg";
            case 'TWITTER':
            case 'TWITTER DIRECT MESSAGES':
            case 'TWITTER PUBLIC':
                return url = "../App_Themes/CXone/icons/social/twitter.svg#twitter";
            case 'VIBER':
            case 'VIBER PUBLIC':
                return url = "../App_Themes/CXone/icons/social/viber.svg#viber";
            case 'WHATS APP':
            case 'WHATSAPP':
            case 'WHATSAPP PUBLIC':
                return url = "../App_Themes/CXone/icons/social/whats-app.svg#whats-app";
            case 'FACEBOOK MESSENGER':
            case 'FACEBOOK PUBLIC':
                return url = "../App_Themes/CXone/icons/social/fb-messenger.svg#fb-messenger";
            case 'YOUTUBE':
            case 'YOUTUBE PRIVATE':
                return url = "../App_Themes/CXone/icons/social/youtube.svg#youtube";
            case 'CUSTOM-PUBLIC':
            case 'CUSTOM-PRIVATE':
                return url = "../App_Themes/CXone/icons/custom-channel.svg#custom-channel";
            case 'LINKEDIN':
            case 'LINKEDIN PRIVATE':
                return url = "../App_Themes/CXone/icons/social/linkedin.svg#linkedin";
            case 'INSTAGRAM PUBLIC':
            case 'INSTAGRAM DM':
                return url = "../App_Themes/CXone/icons/social/instagram.svg#instagram";
            case 'KIK':
            case 'KIK PUBLIC':
                return url = "../App_Themes/CXone/icons/social/kik.svg#kik";
            case 'WECHAT':
            case 'WECHAT PUBLIC':
                return url = "../App_Themes/CXone/icons/social/wechat.svg#wechat";
            case 'GOOGLE PLAY':
                return url = "../App_Themes/CXone/icons/channels/google-play.svg#google-play";
            case 'FORUM PUBLIC':
            case 'FORUM DM':
                return url = "../App_Themes/CXone/icons/channels/forum.svg#forum";
            case 'VOICE IVR':
                return url = "../App_Themes/CXone/icons/channels/voice-ivr.svg#voice-ivr";
            case 'SOCIAL':
                return url = "../App_Themes/CXone/icons/channels/social.svg#social";
            case 'SCREEN':
                return url = "../App_Themes/CXone/icons/channels/screen.svg#screen";
            case 'SENDBIRD':
            case 'SENDBIRD PUBLIC':
                return url = "../App_Themes/CXone/icons/channels/sendbird.svg#sendbird";
            case 'FAX':
                return url = "../App_Themes/CXone/icons/channels/fax.svg#fax";
        }
    }

}
